import { useRef } from "react";
var EMPTY_VALUE = Symbol("useLazyRef empty value");

var useLazyRef = function useLazyRef(init) {
  var resultRef = useRef(EMPTY_VALUE);

  if (resultRef.current === EMPTY_VALUE) {
    resultRef.current = init();
  }

  return resultRef;
};

export { EMPTY_VALUE, useLazyRef };